export default __webpack_public_path__ + "static/media/arrow_front.c7a70f8c.svg";